import { createSlice } from "@reduxjs/toolkit";

const amlAnalysis = createSlice({
    name: "amlAnalysis",
    initialState: {
        isLoading: true,
        amlRiskIndicators:{},
        suspiciousActivities: [],
        monthlyWithdrawalsDeposits: [],
        top10DebitCounterparty: [],
        top10CreditCounterparty: [],
        monthlyMaxMinBalance: [],
        outflows: [],
        inflows: [],
        txnModeDistribution: [],
        monthlyTxns: []
    },
    reducers: {
        setAllAMLAnalysis: (state, { payload }) => {
            state.isLoading = payload.isLoading;
            state.amlRiskIndicators = payload.amlRiskIndicators
            state.monthlyWithdrawalsDeposits = payload.monthlyWithdrawalsDeposits;
            state.suspiciousActivities = payload.suspiciousActivities;
            state.top10CreditCounterparty = payload.top10CreditCounterparty;
            state.top10DebitCounterparty = payload.top10DebitCounterparty;
            state.monthlyMaxMinBalance = payload.monthlyMaxMinBalance;
            state.outflows = payload.outflows;
            state.inflows = payload.inflows;
            state.txnModeDistribution = payload.txnModeDistribution;
            state.monthlyTxns = payload.monthlyTxns;
            state.monthlyMaxMinBalance = payload.monthlyMaxMinBalance;
        }
    }
})

export const { setAllAMLAnalysis } = amlAnalysis.actions

export default amlAnalysis.reducer;